let shuffleFallbackCursor = 0;

export function getSecureRandomIndex(length: number) {
  if (length <= 0) return 0;
  const cryptoApi =
    typeof globalThis !== "undefined" && globalThis.crypto
      ? globalThis.crypto
      : undefined;
  if (cryptoApi?.getRandomValues) {
    const buffer = new Uint32Array(1);
    cryptoApi.getRandomValues(buffer);
    return buffer[0] % length;
  }
  shuffleFallbackCursor = (shuffleFallbackCursor + 1) % length;
  return shuffleFallbackCursor;
}
